import { useColorFromEnum } from '@features/appointment-types';
import {
  ELIG_TOKENS,
  READINESS_TONE,
} from '@features/eligibility-checks/theme/readinessTokens';

import type { CalendarEvent } from '../../../types';
import type { ColorTreatment } from '../types';
import { opaqueTint } from '../utils/colorUtils';

const FUTURE_ALPHA = 0.06;
const PAST_ALPHA = 0.03;

// Accent color drives the actionable variant outline + left stripe AND the
// ExpandedCard hover outline. Priority (most specific wins):
//   1. Cancelled  → red
//   2. Rescheduling → yellow
//   3. Has readiness chip → readiness tone (green / amber / red / gray)
//   4. Default → type color
const CANCELLED_ACCENT = ELIG_TOKENS.red;
const RESCHEDULING_ACCENT = '#CA8A04';

export const useEventColorTreatment = (event: CalendarEvent): ColorTreatment => {
  const resource = event.resource;
  const baseColor = useColorFromEnum(resource.color);
  const reality = resource.block_state?.reality;
  const readiness = resource.block_state?.readiness;
  const encounterStatus = (resource.encounter as { status?: string } | null)?.status;
  const isPast = encounterStatus === 'completed' || resource.no_showed === true;

  let accentColor = baseColor;
  if (reality === 'cancelled') accentColor = CANCELLED_ACCENT;
  else if (reality === 'rescheduling') accentColor = RESCHEDULING_ACCENT;
  else if (readiness) accentColor = ELIG_TOKENS[READINESS_TONE[readiness]];

  return {
    backgroundColor: opaqueTint(baseColor, isPast ? PAST_ALPHA : FUTURE_ALPHA),
    textColor: isPast ? ELIG_TOKENS.inkSoft : ELIG_TOKENS.ink,
    accentColor,
  };
};
